import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2243a7e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pie float-end" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pt1" }, "時間", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pt2" }, "回答状況", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "pie-chart",
      style: _normalizeStyle(_ctx.chartStyle)
    }, null, 4),
    _createElementVNode("div", {
      class: "pie-chart2",
      style: _normalizeStyle(_ctx.chartStyle2)
    }, null, 4),
    _hoisted_2,
    _hoisted_3
  ]))
}